import script from "./TwoFactorRecoveryCodesForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TwoFactorRecoveryCodesForm.vue?vue&type=script&setup=true&lang=js"

import "./TwoFactorRecoveryCodesForm.vue?vue&type=style&index=0&id=56066c74&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56066c74"]])

export default __exports__